import './App.css';
import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { user_data, user_login_state, user_role, w_labels, langs, chosen_lang, redir, surveys, _online, _enablesurvey, _orglogo, _hasorglogo, _otpcountry } from './RecoilState';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Form, Input, Button, message, Checkbox, Spin } from 'antd';
import { UserOutlined, LockOutlined, ArrowRightOutlined, CheckOutlined, CompassOutlined } from '@ant-design/icons';
import Text from './components/Text'
import LangButton from './components/LangButton';
import GrabOrganization from './components/GrabOrganization';
import Surveycard from './components/Surveycard';
// import Survey from './Survey';
import Sinstruction from './components/Sinstruction';
import Survey from './components/Survey';
import _ from 'lodash';
import FirebaseOTP from './firebase/BDMWOTP';
import { format } from 'date-fns';
import Joyride from 'react-joyride';
import BDMWOTP from './firebase/BDMWOTP';
import INMWOTP from './firebase/INMWOTP';
import BYPASSOTP from './firebase/BYPASSOTP';
import GOOGLEOTP from './firebase/GOOGLEOTP';


const Main = () => {

  const [redirect, setRedirect] = useRecoilState(redir);
  const [userdata, setUserdata] = useRecoilState(user_data);
  const [loginstate, setLoginstate] = useRecoilState(user_login_state);
  const [userrole, setUserrole] = useRecoilState(user_role);
  const [labels, setLabels] = useRecoilState(w_labels);
  const [languages, setLanguages] = useRecoilState(langs);
  const [c_lang, setCLang] = useRecoilState(chosen_lang);
  const [loginbutton, setLoginbutton] = useState("enable")
  const [asurveys, setAsurveys] = useRecoilState(surveys);
  const [isonline, setIsonline] = useRecoilState(_online);
  const [formatdob, setFormatdob] = useState("");
  const [run, setRun] = useState(false);
  const [enablesurvey, setEnablesurvey] = useRecoilState(_enablesurvey)
  const [otpcountry, setOtpCountry] = useRecoilState(_otpcountry)

  // useEffect(() => { console.log(enablesurvey) }, []);

  // console.log(languages);

  // useEffect(() => {

  //   // console.group("▶ userdata");
  //   // console.log(userdata);
  //   // console.groupEnd();

  //   console.group("▶ labels");
  //   console.table(labels);
  //   console.groupEnd();

  //   // console.group("▶ surveys");
  //   // console.table(asurveys);
  //   // console.groupEnd();

  //   console.group("▶ redirect");
  //   console.log(redirect);
  //   console.groupEnd();
  // }, [])

  // useEffect(() => { setRedirect("dash") }, [])

  const Languageselection = () => {
    return (
      <>
        {/* Language Selection Screen */}
        <div className="header-accomodate">
          <div className="page-container mx-auto">
            <Text style={"large-gradient-heading"} value={labels[0]} />
            <Text style={"text-heading-large"} value={labels[1]} />
            <div className="spacer"></div>
            <div className="spacer lang-button-container">
              {
                languages.map((value) => {
                  // console.log(value);
                  return (
                    <>
                      <LangButton key={value.key} details={value} />
                    </>)

                })
              }
            </div>
          </div>
        </div>
      </>
    )
  }

  const Welcome = () => {

    const welcomenext = () => {
      setRedirect("tos");
    }

    // useEffect(() => {
    //   const stringDate = userdata.date_of_birth;
    //   const date = new Date(stringDate);
    //   console.log(date);
    //   setFormatdob(date)
    // },[userdata])

    useEffect(() => {
      // console.log(userdata);
      dobformatter()
    }, [])

    function dobformatter() {
      const dateStr = userdata.date_of_birth;
      const formattedDate = format(new Date(dateStr), 'd MMMM, yyyy');
      // console.log(formattedDate)
      setFormatdob(formattedDate)

    }

    //user profile
    return (
      <>
        <div className="header-accomodate">
          <div className="page-container mx-auto">
            {/* name */}
            <div className="mb-5">
              <Text style={"large-gradient-heading"} value={labels[2]} />
              {/* <p className="text-heading-large">{userdata.first_name} {userdata.middle_name} {userdata.last_name}</p> */}
            </div>
            <div className="border-b mb-7">
              <Text style={"text"} value={labels[9]} />
            </div>
            {/* name */}
            <div className="flex mb-2">
              <Text style={"text"} value={labels[53]} /><p className="text"> : {userdata.salutation} {userdata.first_name} {userdata.middle_name} {userdata.last_name}</p>
            </div>
            {/* customerid */}
            <div className="flex mb-2">
              <Text style={"text"} value={labels[55]} /><p className="text"> : {userdata.customer_id}</p>
            </div>
            {/* branch code */}
            <div className="flex mb-2">
              <Text style={"text"} value={labels[54]} /><p className="text"> : {userdata.cluster_id}</p>
            </div>
            {/* branch name */}
            {/* <div className="flex mb-2"> */}
            {/* <Text style={"text"} value={labels[49]} /><p className="text"> : {userdata.cluster_id}</p> */}
            {/* <Text style={"text"} value={labels[49]} /><p className="text"> : Ashulia</p> */}
            {/* </div> */}
            {/* dob */}
            {/* <div className="flex mb-2">
              <Text style={"text"} value={labels[50]} /><p className="text"> : {formatdob}</p>
            </div> */}
            {/* gender */}
            <div className="flex mb-2 spacer">
              <Text style={"text"} value={labels[51]} /><p className="text"> : {userdata.gender}</p>
            </div>

            {/* testing fields */}
            <div className="flex flex-row gap-4">
              <div className="flex">
                <h1>For Official Use</h1>
              </div>
              <div className="flex">
                <h1>ID</h1> <h1> : {userdata.id}</h1>
              </div>
              <div className="flex">
                <h1>User ID</h1> <h1> : {userdata.user_id}</h1>
              </div>
            </div>

            {/* <div className="flex mb-10">
              <Text style={"text"} value={labels[13]} /> <GrabOrganization style={"text"} oid={userdata.acf.organization_user} />
            </div> */}
            <div className="flex justify-center mt-10">
              <Button type="secondary" shape="round" size="large" onClick={() => welcomenext()}>
                <div className="flex justify-center gap-x-4 items-center pb-[10px]">
                  <Text style={"text"} value={labels[14]} />
                  <ArrowRightOutlined />
                </div>
              </Button>
            </div>
          </div>
        </div>
      </>
    )
  }

  // joyride config for onscreen hints and instruction

  const startTour = () => {
    // console.log("click")
    setRun(true)
  };

  const customLocale = {
    last: <Text style={"text-left text-bold"} value={labels[67]} />,
    next: <Text style={"text-left text-bold"} value={labels[14]} />,
    skip: <Text style={"text-left text-bold"} value={labels[66]} />
  }

  const steps = [
    {
      target: '.first-step',
      content: <Text style={"text-left text-bold"} value={labels[72]} />,
      disableBeacon: true
    }
  ];

  const handleJoyrideCallback = (data) => {
    // console.log(data)
    if (data.action === "reset") {
      // console.log("beacon")
      setRun(false);
      // data.lifecycle = "tooltip"
    }
  }

  // joyride config complete

  const Tos = () => {

    const [conf, setConf] = useState(false);

    // useEffect(() => {console.log(conf)}, [conf])

    const handleCheck = () => {
      setConf(!conf);
    }

    const tosNext = () => {
      setRedirect("dash")
    }

    const logoutandreset = () => {
      localStorage.removeItem('respondent_mpu_token')
      localStorage.removeItem('respondent_mpu_persist')
      setRedirect("lang")
      window.location.href = '/';
    }

    return (
      <>
        {enablesurvey ?
          // TOS screen 
          <>
            <div className="header-accomodate">
              <div className="page-container mx-auto">
                <div className="mb-5">
                  <Text style={"large-gradient-heading"} value={labels[15]} />
                </div>
                <div>
                  <div className="flex justify-center items-center mb-5 flex-col h-36">
                    <img src={require('./assets/tos1.gif')} width={150} alt="lock gif" />
                    <Text style={"text"} value={labels[16]} />
                  </div>
                  <div className="flex justify-center items-center mb-1 flex-col gap-5 h-36">
                    <img src={require('./assets/tos2.gif')} width={80} alt="lock gif" />
                    <Text style={"text"} value={labels[17]} />
                  </div>
                  <div className="mt-10 border-t pt-5 flex justify-center items-center">
                    <Checkbox onChange={handleCheck} className='first-step'>
                      <Text style={"text-small"} value={labels[18]} />
                    </Checkbox>
                  </div>
                  <div className="flex justify-center mt-10">
                    {
                      conf ?
                        <>
                          <Button type="secondary" shape="round" size="large" onClick={() => tosNext()}>
                            <div className="flex justify-center gap-x-4 items-center">
                              <Text style={"text"} value={labels[14]} />
                              <ArrowRightOutlined />
                            </div>
                          </Button>
                        </>
                        :
                        <>
                          <Button type="secondary" shape="round" size="large" className='tooltip-disabled-button' onClick={startTour}>
                            <div className="flex justify-center gap-x-4 items-center">
                              <Text style={"text"} value={labels[14]} />
                              <ArrowRightOutlined />
                            </div>
                          </Button>
                        </>
                    }

                  </div>
                </div>
              </div>
            </div>
          </>
          :
          // Survey already completed
          <>
            <div className="header-accomodate">
              <div className="page-container mx-auto">
                <div className="h-[75vh] mx-auto flex flex-col items-center justify-center">
                  <div className="mb-5 pb-8">
                    <div>
                      <div className="flex justify-center items-center mb-5 flex-col h-40">
                        <img src={require('./assets/complete.gif')} width={200} alt="lock gif" />
                      </div>
                    </div>
                    <div className="flex flex-col items-center gap-4 justify-center">
                      {/* <p className="gradient-small">complete</p> */}
                      <Text style={"gradient-heading"} value={labels[35]} />
                      <Text style={"text-survey leading-7"} value={labels[36]} />

                    </div>
                  </div>

                  <div className="flex flex-col justify-center mt-5 mb-2">
                    {/* <p className="mb-2 mt-5">FOR TESTING PURPOSES ONLY</p> */}
                    <Button type="secondary" shape="round" size="large" onClick={() => logoutandreset()}>
                      <div className="flex justify-center gap-x-4 items-center">
                        <p>LogOut</p>
                        {/* <ArrowRightOutlined /> */}
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      </>
    )
  }

  const Dashboard = () => {

    const logoutandreset = () => {
      localStorage.removeItem('respondent_mpu_token')
      localStorage.removeItem('respondent_mpu_persist')
      setRedirect("lang")
      window.location.href = '/';
    }

    return (
      <>
        <div className="header-accomodate">
          <div className="page-container mx-auto">
            <div className="mb-5">
              <div className='flex flex-row justify-between items-center'>
                <Text style={"large-gradient-heading"} value={labels[19]} />
                <Button type="secondary" shape="round" size="small" onClick={() => logoutandreset()}>
                  <p className='text-[14px] bold'>Log Out</p>
                </Button>
              </div>
              <p className="text-heading-large">{userdata.first_name} {userdata.middle_name} {userdata.last_name}</p>
            </div>
            <div className="spacer survey-container">
              {
                asurveys.map((value, i) => {
                  // console.log(value);
                  return (
                    <>
                      <Surveycard value={value} />
                    </>)
                })
              }
            </div>

          </div>
        </div>
      </>
    )
  }

  const errorhandler = () => {
    setRedirect("err");
  }

  const Error = () => {

    return (
      <>
        <div className="header-accomodate">
          <div className="m-auto">
            <div className="mb-5">
              <p className="large-gradient-heading text-center">404</p>
              <p className="text-heading-large text-center">Refresh This Page or Try Again</p>
            </div>
            <div className="flex justify-center mt-5 mb-2">
              <Button type="secondary" shape="round" size="large" onClick={() => errorhandler()}>
                <div className="flex justify-center gap-x-4 items-center">
                  <Text style={"text"} value={labels[14]} />
                  <ArrowRightOutlined />
                </div>
              </Button>
            </div>
          </div>
        </div>
      </>
    )
  }

  const SurveyPaused = () => {
    return (
      <>
        <div className='flex flex-col h-[40vh]'>
          <div className='m-auto'>
            <p className='p-[30px] text-center sub-heading padding15px'>
              Thank you for participating. We are getting ready for rollout. Further details will be shared soon.
            </p>
            <p className='p-[30px] text-center sub-heading padding15px'>
              অংশগ্রহণের জন্য আপনাকে ধন্যবাদ। আমরা রোলআউট এর জন্য প্রস্তুতি নিচ্ছি। আরও বিস্তারিত তথ্য শীঘ্রই জানানো হবে
            </p>
          </div>
        </div>
      </>
    )
  }

  // useEffect(() => {setRedirect("dash")}, [])

  return (
    <>
      {
        (redirect === "lang") ? <Languageselection /> :
          // (redirect === "lang") ? <SurveyPaused /> :
          // (redirect === "login") ? <LoginScreen /> :
          (redirect === "login") ?
            <>
              {
                otpcountry === "in" ? <INMWOTP /> : otpcountry === "bd" ? <BDMWOTP /> : otpcountry === "fireb" ? <GOOGLEOTP /> : <BYPASSOTP />
              }
              {/* <INMWOTP /> */}
              {/* <BDSERVEROTP /> */}
              {/* <BYPASSOTP /> */}
              {/* <GOOGLEOTP /> */}
            </>
            :
            (redirect === "welcome") ? <Welcome /> :
              (redirect === "tos") ? <Tos /> :
                (redirect === "survey") ? <Survey /> :
                  <Dashboard />
        // (redirect === "dash") ?  : <Error />
      }
      {/* joyride onscreen config */}
      <>
        <Joyride
          // callback={handleJoyrideCallback}
          continuous
          hideCloseButton
          run={run}
          scrollToFirstStep
          // showProgress
          showSkipButton
          steps={steps}
          callback={handleJoyrideCallback}
          locale={customLocale}
          styles={{
            options: {
              zIndex: 10000,
              overlayColor: '#F46F36'
            },
          }}
        />
      </>
    </>
  );
}

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* <FirebaseOTP /> */}
          <Route exact path="/" element={<Main />} />
          {/* <Route exact path="/app" element={<App />} /> */}
          {/* <Route exact path="/survey" element={<Survey />} /> */}
        </Routes>
      </Router>
    </>
  )
}

export default App

